var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCelsius(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.924 25.924",
    fill: "currentColor",
    "aria-label": "Celsius",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.699,2.278C2.107,2.278,0,4.386,0,6.977c0,2.593,2.107,4.698,4.699,4.698s4.7-2.106,4.699-4.698     C9.398,4.386,7.291,2.278,4.699,2.278z M4.699,9.327c-1.295,0-2.35-1.054-2.35-2.35c0-1.294,1.055-2.35,2.35-2.35     s2.35,1.055,2.35,2.35C7.049,8.273,5.994,9.327,4.699,9.327z M21.324,19.971c-3.91,0-6.227-2.463-6.227-6.369     c0-4.342,2.721-6.456,6.195-6.456c1.592,0,2.836,0.349,3.703,0.725l0.928-3.475c-0.782-0.435-2.52-0.869-4.807-0.869     c-5.904,0-10.652,3.678-10.652,10.336c0,5.558,3.475,9.783,10.221,9.783c2.346,0,4.198-0.464,4.979-0.841l-0.637-3.473     C24.131,19.709,22.683,19.971,21.324,19.971z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelsius);
export default __webpack_public_path__ + "static/media/celsius.32fd6e49c50219270124932fb2c12863.svg";
export { ForwardRef as ReactComponent };